import { useState } from 'react';
import { Mail } from 'lucide-react';
import { Reveal, SectionLabel, SunMark } from './Common';
import { associationEmail, socialLinks } from '../contactData';

const SUBJECTS = ['Informazioni', 'Unisciti a noi', 'Collaborazioni', 'Merchandising'];

export const Contact = () => {
  const [subject, setSubject] = useState(SUBJECTS[0]);
  const instagram = socialLinks.find(link => link.id === 'instagram');
  const facebook = socialLinks.find(link => link.id === 'facebook');
  const mailto = associationEmail
    ? `mailto:${associationEmail}?subject=${encodeURIComponent(`Fantasti100 — ${subject}`)}&body=${encodeURIComponent('Hai un\'idea da condividere, una proposta da farci o semplicemente voglia di salutarci? Oppure sei curioso di scoprire il merch Fantasti100? Scrivici pure qui sotto, ti risponderemo con piacere.\n\n')}`
    : null;

  return <section id="scrivici" className="contact section-pad" data-testid="contact-section">
    <SectionLabel number="05" id="contact">LA PROSSIMA BELLA STORIA INIZIA QUI</SectionLabel>
    <div className="contact-grid">
      <Reveal className="contact-copy">
        <h2 className="display-heading" data-testid="contact-title">Hai un po’<br />di <em>sana follia?</em></h2>
        <p data-testid="contact-description">Vuoi sporcarti le mani, proporci un’idea<br className="desktop-break" /> o semplicemente salutarci?<br />La nostra cassetta delle lettere è aperta.</p>
        <div className="contact-stamp"><SunMark /><span>MENO FORMALITÀ.<br />PIÙ FANTASTI100.</span></div>
      </Reveal>
      <Reveal delay={0.15} className="contact-form-wrap contact-mail-wrap">
        <div className="contact-mail" data-testid="contact-mail">
          <span className="eyebrow contact-mail-eyebrow">SCRIVICI IN UN CLIC</span>
          <p className="contact-mail-lead">Scegli l’argomento e premi il pulsante: si apre direttamente il tuo programma di posta, con destinatario e oggetto già pronti. Nessun modulo da compilare e nessun dato lasciato sul sito.</p>
          <label className="contact-mail-field" htmlFor="contact-subject">Di cosa parliamo?
            <select id="contact-subject" value={subject} onChange={(event) => setSubject(event.target.value)} data-testid="contact-subject">{SUBJECTS.map(option => <option key={option}>{option}</option>)}</select>
          </label>
          {mailto
            ? <a className="button button-dark contact-mail-btn" href={mailto} data-testid="contact-mail-button"><Mail size={19} /> Scrivici via email</a>
            : <span className="contact-mail-pending" data-testid="contact-mail-pending">Indirizzo email in fase di attivazione.</span>}
          {associationEmail && <a className="contact-mail-address" href={mailto} data-testid="contact-mail-address">{associationEmail}</a>}
          <div className="contact-mail-alt" data-testid="contact-mail-alt"><span>Preferisci i social?</span><a href={instagram.url} target="_blank" rel="noopener noreferrer" data-testid="contact-alt-instagram">Instagram</a><a href={facebook.url} target="_blank" rel="noopener noreferrer" data-testid="contact-alt-facebook">Facebook</a></div>
        </div>
      </Reveal>
    </div>
  </section>;
};
